/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#imgSRDC[_ngcontent-%COMP%]{width:50%;margin-left:25%;margin-top:10%;margin-bottom:2%}#forgotPassForm[_ngcontent-%COMP%]{width:50%;margin-left:25%}#generateButton[_ngcontent-%COMP%]{width:100%;margin-top:1%}.ui.form-group[_ngcontent-%COMP%]{margin:1% 0}\n/*# sourceMappingURL=forgot-password.component.css.map*/"];
export { styles as styles };
